export function parseHTML(text: string): string {
  const parser = new DOMParser();
  const parsed = parser.parseFromString(text, 'text/html');
  return parsed?.body?.innerHTML || '';
}

const validTags = new RegExp(
  /<h1>|<h2>|<h3>|<p>|<span>|<strong>|<em>|<u>|<ul>|<ol>|<li>|<a>|<br>|<blockquote>/,
);
export function containsHTML(text: string): boolean {
  return validTags.test(text);
}

export const stripTags = (str: string) => str.replace(/<[^>]+>/gi, '');
